import { Vue } from "vue-class-component";

export default class MasterPage extends Vue {}
